import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FetchSlotsOpenUrlParams } from '../../api/fetchers/slots/slotsOpenUrl';
import { fetchSlotsOpenUrl } from '../../api/fetchers/slots/slotsOpenUrl';
import { Logger } from '../../logger/Logger';
import { getWindowObject } from '../../utils/window';

export interface FetchSlotsOpenUrlActionParams extends Omit<FetchSlotsOpenUrlParams, 'signal' | 'gameID'> {
  lobbyType: string;
  overrideParams?: Record<string, string>;
}

export const fetchSlotsOpenUrlAction = createAsyncThunk(
  'tables/fetchSlotsOpenUrl',
  async ({ lobbyType, overrideParams, ...params }: FetchSlotsOpenUrlActionParams, { signal, rejectWithValue }) => {
    const redirectOrigin = getWindowObject();
    let redirectUrl = await fetchSlotsOpenUrl({ ...params, signal: signal, gameID: lobbyType });
    if (!redirectUrl) {
      return rejectWithValue('No redirect URL');
    }
    if (overrideParams) {
      try {
        const parsedUrl = new URL(redirectUrl);
        Object.entries(overrideParams).forEach(([key, value]) => {
          parsedUrl.searchParams.set(key, value);
        });
        redirectUrl = parsedUrl.toString();
      } catch (error) {
        Logger.logFailure('parsingSlotRedirectUrl');
      }
    }
    redirectOrigin.open(redirectUrl.toString(), '_self');

    return redirectUrl;
  }
);
